import React, { useMemo } from "react";
import useResources from "../../hooks/useResources";

export const findName = (employees, client_id) => {
  const foundClient = (employees || []).find(
    (employee) => employee.id === client_id
  );

  return foundClient ? foundClient.name : `No name for ${client_id}`;
};

const ClientCell = ({ data }) => {
  const { clients } = useResources();

  const client_id = useMemo(() => {
    if (data && data.data && data.data.client_id) return data.data.client_id;
  }, [data]);

  return <>{findName(clients, client_id)}</>;
};

export default ClientCell;
